
import { defineComponent } from 'vue';
import Spoiler from "../components/Spoiler.vue";

export default defineComponent({

    components: {
      Spoiler
    },
    data() {
        return {
            values: false
        };
    }
});
